// extracted by mini-css-extract-plugin
module.exports = {"section":"partners-module--section--1XGw7","title":"partners-module--title--2G1s2","desc":"partners-module--desc--1H_w1"};